import "./VehiclesHeader.scss";

import Add from "@mui/icons-material/Add";

import { useDispatch } from "react-redux";

import { openDrawer } from "../../../slices/drawerSlice";

import { LargeTitle } from "../../../common-components/Titles/Titles";
import { Button } from "../../../common-components/Buttons/Buttons";

import VehiclesCreate from "../VehiclesCreate/VehiclesCreate";
import VehiclesCreateFooter from "../VehiclesCreate/components/VehiclesCreateFooter/VehiclesCreateFooter";

const VehiclesHeader = () => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openDrawer({content: <VehiclesCreate/>, footer: <VehiclesCreateFooter/>}));
    }

    return (
        <div className={"vehicles-header"}>
            <div className={"vehicles-header_container"}>
                <div className={"vehicles-header_title"}>
                    <LargeTitle property={"Транспорт"}/>
                </div>
                <div className={"vehicles-header_button"}>
                    <Button Icon={Add} title={"Добавить"} onClick={handleOpen}/>
                </div>
            </div>
        </div>
    )
}

export default VehiclesHeader;